export const privacyData = [
  {
    id: "collection",
    titleAr: "1. جمع المعلومات",
    titleEn: "1. Information Collection",
    contentAr:
      "نقوم بجمع المعلومات التي تقدمها لنا مباشرة عند الاستفسار عن منتجاتنا من الأنابيب المعدنية، بما في ذلك الاسم، بيانات الاتصال، وتفاصيل الشركة.",
    contentEn:
      "We collect information you provide directly to us when inquiring about our metal pipe products, including name, contact details, and company information.",
  },
  {
    id: "usage",
    titleAr: "2. استخدام البيانات",
    titleEn: "2. Use of Data",
    contentAr:
      "تُستخدم البيانات لتحسين كفاءة التصنيع، تخصيص العروض الفنية، وتسهيل عمليات الشحن والتوريد لعملائنا.",
    contentEn:
      "Data is used to improve manufacturing efficiency, customize technical offers, and facilitate shipping and supply operations for our clients.",
  },
  {
    id: "security",
    titleAr: "3. أمن المعلومات",
    titleEn: "3. Information Security",
    contentAr:
      "نلتزم بتطبيق أعلى معايير التشفير والحماية المادية والرقمية لضمان سلامة بياناتكم ضد أي اختراق أو تسريب.",
    contentEn:
      "We are committed to applying the highest standards of encryption and physical and digital protection to ensure the safety of your data against any breach or leakage.",
  },
  {
    id: "third-party",
    titleAr: "4. مشاركة المعلومات مع أطراف ثالثة",
    titleEn: "4. Third-Party Sharing",
    contentAr:
      "لا نقوم ببيع بياناتكم، ولكن قد نشاركها مع شركاء الخدمات اللوجستية المعتمدين لضمان وصول الشحنات إلى مواقعكم.",
    contentEn:
      "We do not sell your data, but we may share it with authorized logistics partners to ensure shipments reach your locations.",
  },
  {
    id: "retention",
    titleAr: "5. الاحتفاظ بالبيانات",
    titleEn: "5. Data Retention",
    contentAr:
      "نحتفظ بسجلات المعاملات الصناعية والبيانات الشخصية طوال الفترة اللازمة للامتثال للمعايير القانونية والضريبية.",
    contentEn:
      "We retain industrial transaction records and personal data for as long as necessary to comply with legal and tax standards.",
  },
  {
    id: "rights",
    titleAr: "6. حقوق المستخدم",
    titleEn: "6. User Rights",
    contentAr:
      "يحق لك طلب نسخة من بياناتك المخزنة لدينا أو طلب تعديلها أو حذفها في أي وقت من خلال التواصل مع قسم الدعم.",
    contentEn:
      "You have the right to request a copy of your stored data, or request to modify or delete it at any time by contacting our support department.",
  },
];

export const termsData = [
  {
    id: "agreement",
    titleAr: "1. الاتفاقية القانونية",
    titleEn: "1. Legal Agreement",
    contentAr:
      "باستخدامك لموقع الدولية، فإنك تقر بموافقتك الكاملة على هذه الشروط والأحكام والالتزام بكافة القوانين واللوائح المعمول بها.",
    contentEn:
      "By using Al Dawlia website, you acknowledge your full agreement to these terms and conditions and compliance with all applicable laws and regulations.",
  },
  {
    id: "intellectual",
    titleAr: "2. الملكية الفكرية",
    titleEn: "2. Intellectual Property",
    contentAr:
      "جميع المحتويات بما في ذلك الشعارات، التصاميم الهندسية للأنابيب، والصور هي ملكية حصرية لشركة الدولية ومحمية بموجب قوانين الملكية الدولية.",
    contentEn:
      "All content, including logos, engineering designs of pipes, and images, is the exclusive property of Al Dawlia and is protected under international property laws.",
  },
  {
    id: "usage-limit",
    titleAr: "3. حدود الاستخدام",
    titleEn: "3. Usage Limitations",
    contentAr:
      "يُمنع منعاً باتاً استخدام أي مادة من الموقع لأغراض تجارية دون الحصول على إذن كتابي مسبق من الإدارة العليا للشركة.",
    contentEn:
      "It is strictly prohibited to use any material from the site for commercial purposes without obtaining prior written permission from the company's senior management.",
  },
  {
    id: "liability",
    titleAr: "4. حدود المسؤولية",
    titleEn: "4. Limitation of Liability",
    contentAr:
      "الدولية غير مسؤولة عن أي أضرار ناتجة عن استخدام أو عدم القدرة على استخدام المعلومات الواردة في هذا الموقع.",
    contentEn:
      "Al Dawlia is not liable for any damages resulting from the use or inability to use the information provided on this website.",
  },
  {
    id: "modifications",
    titleAr: "5. تعديل الشروط",
    titleEn: "5. Modifications of Terms",
    contentAr:
      "تحتفظ الشركة بالحق في مراجعة وتعديل هذه الشروط في أي وقت دون إشعار مسبق، وتصبح التعديلات نافذة فور نشرها.",
    contentEn:
      "The company reserves the right to revise and modify these terms at any time without prior notice, and modifications become effective immediately upon posting.",
  },
];
